import { InputSwitch } from './InputSwitch'

export default InputSwitch
